import {perDay} from 'core/LifeCycle';
import {getTodayStartTime, daysBetween} from 'shared/utils/dateTime';

export function couldSpendSinceStart(budget: Budget): MoneyAmount {
  const todayStart = getTodayStartTime();
  const since = budget.startDate;

  const daysPassed = daysBetween(todayStart, since);
  const dailyAmount = perDay(budget);

  return dailyAmount * daysPassed;
}
